module.exports = __webpack_public_path__ + "static/media/Pheasant.svg";